import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm13.47 11.11-2.3-2.29-4-4-2.28-2.29a1.75 1.75 0 0 0-3 1.23v8.59a1.75 1.75 0 0 0 1.76 1.75h8.58a1.75 1.75 0 0 0 1.24-3Zm-1 1.33a.23.23 0 0 1-.23.16H3.65a.25.25 0 0 1-.25-.25V3.76a.26.26 0 0 1 .15-.23h.1a.24.24 0 0 1 .18.08l1.76 1.74-.48.47a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l.48-.47.94.94-.48.47a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l.48-.47.94.94-.48.47a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l.48-.47 1.76 1.76a.23.23 0 0 1 .05.27ZM7 11.56H4.65a.24.24 0 0 1-.25-.24V8.93a.24.24 0 0 1 .42-.16l2.39 2.37a.24.24 0 0 1-.21.42Z';
const draw24px =
  'M20.83,19m-10-8M6.5,18.09h4.61a.58.58,0,0,0,.41-1L6.91,12.48a.58.58,0,0,0-1,.42v4.61A.58.58,0,0,0,6.5,18.09Zm14.87,1.72a2.26,2.26,0,0,1-2.12,1.42H5.07a2.31,2.31,0,0,1-2.3-2.32V4.52A2.31,2.31,0,0,1,4.21,2.37a2.25,2.25,0,0,1,2.49.51l7,7.13,0,0,0,0L17,13.28h0l3.91,4A2.28,2.28,0,0,1,21.37,19.81Zm-1.55-1.49-3.39-3.44-1,1a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l1-1-2.16-2.19-1,1a.75.75,0,0,1-.53.22.79.79,0,0,1-.53-.22.75.75,0,0,1,0-1.06l1-1L10,8.36l-1,1a.74.74,0,0,1-.53.22.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l1-1L5.64,3.93a.79.79,0,0,0-.55-.23.66.66,0,0,0-.31.06.78.78,0,0,0-.51.76V18.91a.81.81,0,0,0,.8.82H19.25a.79.79,0,0,0,.74-.5A.82.82,0,0,0,19.82,18.32Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const RulerTriangleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'rulerTriangle')) as IconWithRender;

RulerTriangleIcon.displayName = 'RulerTriangleIcon';
RulerTriangleIcon.propTypes = Icon.propTypes;
RulerTriangleIcon.renderIcon = (props) => <RulerTriangleIcon {...props} />;
export default RulerTriangleIcon;
